import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SortOrder } from '../../../model/sort-order';
import { Device } from '../../../model/device';
import { DeviceFilters } from '../../../model/filters/device-filters';
import { DeviceCategory } from '../../../model/device-category';
import { TenantsService } from '../../../services/tenants.service';
import { DevicesService } from '../../../services/devices.service';
import { Tenant } from '../../../model/tenant';
import { ActionButton } from '../../../model/ui/action-button';
import { SelectItem } from 'primeng/api';
import { Organization } from '../../../model/organization';

@Component({
  selector: 'app-device-selector',
  templateUrl: './device-selector.component.html',
  styleUrls: ['./device-selector.component.scss']
})
export class DeviceSelectorComponent {

  private readonly DEFAULT_DEVICES_SORT_FIELD = 'serialNumber';
  private readonly DEFAULT_DEVICES_SORT_ORDER = 1;

  @Input() tenant: Tenant;
  @Input() organization: Organization;
  @Input() actionButtons: ActionButton[];
  @Input() selectionMode: 'single' | 'multiple' = 'single';
  @Output() selectionChange: EventEmitter<Device | Device[]>;
  @Output() visibleChange: EventEmitter<boolean>;

  public dialogVisible: boolean;

  public deviceSelection: Device | Device[];

  public deviceFilters: DeviceFilters;

  public initialSelection: Device | Device[];

  constructor() {
    this.selectionChange = new EventEmitter<Device | Device[]>();
    this.visibleChange = new EventEmitter<boolean>();
    this.deviceFilters = {};
    this.deviceFilters.sortField = this.DEFAULT_DEVICES_SORT_FIELD;
    this.deviceFilters.sortOrder = this.DEFAULT_DEVICES_SORT_ORDER;
  }

  ngOnInit(): void {}

  @Input()
  set visible(visible: boolean) {
    this.dialogVisible = visible;
  }

  @Input()
  set selection(selection: Device | Device[]) {
    this.initialSelection = selection;

    if (this.selectionMode === 'multiple') {
      const arraySelection = selection as Device[];
      this.deviceSelection = [...arraySelection];

    } else if (this.selectionMode === 'single') {
      const objectSelection = selection as Device;
      if (objectSelection) {
        this.deviceSelection = objectSelection;
      }
    }
  }

  public saveAndClose(): void {
    this.selectionChange.emit(this.deviceSelection);
    this.visible = false;
    this.visibleChange.emit(false);
  }

  public closeWithoutSaving(): void {
    this.selection = this.initialSelection;
    this.visible = false;
    this.visibleChange.emit(false);
  }

}
